<template>
  <vs-card>
    <vs-table hoverFlat stripe :data="shippings" search pagination max-items="15">
      <template slot="header">
        <h3>
          Átvételi módok
        </h3>
        <vs-button radius color="success" type="gradient" icon="add" @click="addShipping()"></vs-button>
      </template>
      <template slot="thead">
        <vs-th>
          Megnevezés
        </vs-th>
        <vs-th>
        </vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(tr, index) in data">
          <vs-td>
            {{ tr.ShippingName }}
          </vs-td>
          <vs-td>
            <vs-row vs-type="flex" vs-align="right" vs-justify="flex-end">
              <vs-button radius color="warning" size="small" type="gradient" icon="build"
                         @click="editShipping(tr.Id)"></vs-button>
              <vs-button v-if="parseInt(tr.Deletable) === 1" radius color="danger" size="small" type="gradient" icon="clear"
                         @click="delShipping(tr.Id)"></vs-button>
            </vs-row>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="centerx">
      <vs-popup classContent="addShippingModal" title="Új átvételi mód hozzáadása" :active.sync="addModal"
                @closemodal="closeModal()">
        <new_shipping v-bind:selected="selected"></new_shipping>
      </vs-popup>
    </div>

    <div class="centerx">
      <vs-popup classContent="editShippingModal" title="Átvételi mód módosítása" :active.sync="editModal"
                @closemodal="closeModal()">
        <edit_shipping v-bind:selected="selected"></edit_shipping>
      </vs-popup>
    </div>
  </vs-card>
</template>

<script>
import {axiosInstance} from "@/main";
import new_shipping from "../../components/modals/new_shipping";
import edit_shipping from "../../components/modals/edit_shipping";

export default {
  name: "shippings",
  data() {
    return {
      shippings: [],
      editModal: false,
      addModal: false,
      selected: {
        Id: '',
        ShippingName: '',
        Deletable: ''
      }
    }
  },
  components: {
    new_shipping, edit_shipping
  },
  methods: {
    closeModal() {
      this.editModal = false;
      this.addModal = false;
      this.getShippings();
    },
    getShippings() {
      let self = this;
      axiosInstance
          .get('admin/shippingController.php', {
            withCredentials: true,
          })
          .then((response) => {
            this.shippings = response.data.responseData;
          })
          .catch((err) => {
            if (err.response.status === 401)
              self.$root.exterminatus(err.response.data.message);
            else {
              self.$vs.notify({
                title: 'Rendszerüzenet',
                position: 'top-right',
                text: err.response.data.message,
                color: 'danger',
                icon: 'error'
              });
            }
          });
    },
    addShipping() {
      this.selected.ShippingName = '';
      this.addModal = true;
    },
    editShipping(id) {
      this.selected = {...this.shippings.find(elem => elem.Id === id)};
      this.editModal = true;
    },
    delShipping(id) {
      let self = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Megerősítés`,
        text: 'Valóban törölni kívánja az átvételi módot?',
        acceptText: 'Igen',
        cancelText: 'Nem',
        accept: function () {
          axiosInstance
              .delete('admin/shippingController.php?id=' + id, {
                withCredentials: true,
              })
              .then((resp) => {
                self.getShippings();
                self.$vs.notify({
                  title: 'Rendszerüzenet',
                  position: 'top-right',
                  text: resp.data.status === 'OK' ? 'Sikeres törlés.' : 'Sikertelen törlés. ' + resp.data.message,
                  color: resp.data.status === 'OK' ? 'success' : 'danger',
                  icon: resp.data.status === 'OK' ? 'check_box' : 'error'
                });
              })
              .catch((err) => {
                if (err.response.status === 401)
                  self.$root.exterminatus(err.response.data.message);
                else {
                  self.$vs.notify({
                    title: 'Rendszerüzenet',
                    position: 'top-right',
                    text: err.response.data.message,
                    color: 'danger',
                    icon: 'error'
                  });
                }
              });
        }
      });
    }
  },
  created() {
    this.getShippings();
  }
}
</script>

<style scoped>
h3 {
  padding: 15px;
}

.vs-input {
  margin-top: 15px;
  margin-bottom: 15px;
  width: 100%;
}

form {
  width: 100%;
}

.vs-icon {
  margin-left: 15px;
}

.vs-button {
  margin: 1px 5px;
}

</style>